import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const StyledCloseButton = styled(IconButton)`
    margin-left: 8px;
    &:hover {
        .SWReactIcons svg path {
            fill: ${colorsPalettes.carbon[0]};
        }
    }
`;
